// extracted by mini-css-extract-plugin
export default {"disableTransitions":"jlN42NuWp3ItnLuzm0EZ"};